export default __webpack_public_path__ + "static/media/pexels-cottonbro-8145798_glass_9.45.47.32666f7a.mp4";